import Vue from 'vue';
import Vuex from 'vuex';
import {
  setData,
  resultField,
  newLotteryField,
  listField
} from '@/helper/index';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: {
      name: '年会抽奖',
    },
    result: {
    },
    newLottery: [{
      key: 'firstPrize',
      name: '一等奖',
      count: 1,
      num: 1,
      award: '',
      allIn: false
    }],
    list: [],
    photos: []
  },
  mutations: {
    setClearConfig(state) {
      state.config = {
        name: '年会抽奖'
      };
      state.newLottery = [{
        name: '一等奖',
        count: 1,
        num: 1,
        award: '',
        allIn: false
      }];
    },
    setClearList(state) {
      state.list = [];
    },
    setClearPhotos(state) {
      state.photos = [];
    },
    setClearResult(state) {
      state.result = {
      };
    },
    setClearStore(state) {
      state.config = {
        name: '年会抽奖'
      };
      state.result = {
      };
      state.newLottery = [{
        key: 'firstPrize',
        name: '一等奖',
        count: 1,
        num: 1,
        award: '',
        allIn: false
      }];
      state.list = [];
      state.photos = [];
    },
    setConfig(state, config) {
      state.config = config;
    },
    setResult(state, result = {}) {
      state.result = result;

      setData(resultField, state.result);
    },
    setNewLottery(state, newLottery) {
      if (state.newLottery.find(item => item.name === newLottery.name)) {
        return;
      }
      state.newLottery.push(newLottery);
      setData(newLotteryField, state.newLottery);
    },
    setList(state, list) {
      state.list = list;
      setData(listField, list);
    },
    setPhotos(state, photos) {
      state.photos = photos;
    }
  },
  actions: {},
  modules: {}
});
